/**
 * Labstep
 *
 * @module core/Text/Error
 * @desc TextError (red color for error)
 */

import { Icon } from 'labstep-web/core/Icon';
import type React from 'react';
import styles from './styles.module.scss';
import type { ICoreTextErrorProps } from './types';

export const TextError: React.FC<ICoreTextErrorProps> = ({
  children,
  withIcon,
}) => (
  <span className={styles.textError} data-testid="text-error">
    {withIcon && <Icon name="exclamation triangle" />}
    {children}
  </span>
);
